export const DOMAIN = 'vacancies';

export enum ESubdomain {
  AddVacancy = 'AddVacancy',
  PreviewVacancy = 'PreviewVacancy',
  UpdateVacancy = 'UpdateVacancy',
  Vacancies = 'Vacancies',
}

export enum EErrorType {
  RegionsFetchError = 'RegionsFetchError',
  UserFetchError = 'UserFetchError',
  VacancyFetchError = 'VacancyFetchError',
  VacanciesFetchError = 'VacanciesFetchError',
  SearchCatalogItemsFetchError = 'SearchCatalogItemsFetchError',
  UpdateVacancyDateError = 'UpdateVacancyDateError',
  UpdateVacancyError = 'UpdateVacancyError',
  AddVacancyError = 'AddVacancyError',
  DeleteVacancyError = 'DeleteVacancyError',
  UnknownVacancyIdError = 'UnknownVacancyIdError',
}
